import {createArrayIntentType} from '../intent';
import type {Style} from './types';

export const runtimeStyleIntent = createArrayIntentType(
  'StyleIntent',
  (decorate) =>
    (styles: Style.RuntimeStyles): Style.RuntimeIntent =>
      decorate(styles),
);

export const lazyStyleIntent = createArrayIntentType<Style.LazyStylesFunction>(
  'LazyStyleIntent',
  (decorate) =>
    (...args) =>
      // Need to force cast to Style.Intent because the
      // compiled styles type is missing from the args array.
      // This is safe to do because the second parameter is not
      // exposed to users but it's being added by the Sail X babel plugin.
      decorate(args) as unknown as Style.Intent,
);

export const lazyGlobalStyleIntent =
  createArrayIntentType<Style.LazyGlobalStylesFunction>(
    'LazyGlobalStyleIntent',
    (decorate) => (styles) => decorate(styles),
  );
